import React, {Component} from "react"
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Slider from "react-slick"
import styled from "styled-components"
import {GatsbyImage} from "gatsby-plugin-image"
// import GalleryLightbox from "./GalleryLightbox"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faAngleLeft, faAngleRight} from "@fortawesome/free-solid-svg-icons"


const Wrapper = styled.div`
`


const SliderStyled = styled(Slider)`
    padding: 0 3rem;
    margin-bottom: 3rem;

    .gatsby-image-wrapper { 
        width: 100%;
    }

    .slick-dots {
        bottom: -5rem
    }
    .slider-arrow {
        left: 0;
        svg {
            color: ${props => props.theme.colors.primary}!important;
        }
        &.next {
            left: auto;
            right: 0;
        }
    }
`

class GallerySlider extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalOpen: false,
            activeImage: 0,
            lightboxImages: [],
            photoIndex: 0,
            isOpen: false,
        }

        this.toggleModal = this.toggleModal.bind(this)
    }

    componentDidMount() {
        this.getSliderImages(this.props.images)
    }

    toggleModal() {
        this.setState({
            modalOpen: !this.state.modalOpen
        })
    }

    openOnKeyDown = (e, index) => {
        if (e.keyCode === 13) {
            this.setState({photoIndex: index, isOpen: true})
        }
    }

    getSliderImages = (images) => {
        let lightboxImages = []
        images.map((image, i) => {
            lightboxImages.push(image.localFile.publicURL)
        })

        this.setState({
            lightboxImages
        })
    }

    sliderImagesHtml = (images) => {
        let postHtml = images.map((image, i) => {
            return (
                <div
                    key={i}
                    className="px-1"
                    role="button" aria-pressed="false"
                    tabIndex={i}
                    onClick={() => this.setState({photoIndex: i, isOpen: true})}
                    onKeyDown={(e) => this.openOnKeyDown(e, i)}
                >
                    <GatsbyImage image={image.localFile.resize.gatsbyImageData} alt={image.altText}/>
                </div>
            )
        })

        return postHtml
    }

    render() {
        const {images} = this.props
        const {photoIndex, isOpen, lightboxImages} = this.state;

        function PrevButton({onClick}) {
            return (
                <button onClick={onClick} className="slider-arrow prev" aria-label="Previous">
                    <FontAwesomeIcon icon={faAngleLeft}/>
                </button>
            )
        }

        function NextButton({onClick}) {
            return (
                <button onClick={onClick} className="slider-arrow next" aria-label="Next">
                    <FontAwesomeIcon icon={faAngleRight}/>
                </button>
            )
        }

        //slider settings
        const settings = {
            dots: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            lazyload: true,
            prevArrow: <PrevButton/>,
            nextArrow: <NextButton/>,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
            ]
        }

        return (
            <Wrapper>
                <SliderStyled {...settings}>
                    {this.sliderImagesHtml(images)}
                </SliderStyled>
                {isOpen && (
                    <Lightbox
                        mainSrc={lightboxImages[photoIndex]}
                        nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
                        prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
                        onCloseRequest={() => this.setState({isOpen: false})}
                        onMovePrevRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + lightboxImages.length - 1) % lightboxImages.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + 1) % lightboxImages.length,
                            })
                        }
                    />
                )}
            </Wrapper>


        )
    }
}

export default GallerySlider